import { updateTemplateSectionCache } from 'graphql/cache/sections';

import { TEMPLATE_SECTION } from 'graphql/fragments/sections';
import { GET_TEMPLATE_SECTION_QUESTIONS_V2 } from 'graphql/queries/questions';
import { GET_TEMPLATE_SECTION_SONG_IDEAS_SONGS } from 'graphql/queries/songIdeas';
import {
  CLONE_TEMPLATE_SECTION_QUESTION,
  CREATE_TEMPLATE_SECTION_QUESTION_V2,
  DELETE_TEMPLATE_SECTION_QUESTION,
  // MOVE_QUESTIONS_BETWEEN_TEMPLATE_SECTIONS,
  REORDER_TEMPLATE_SECTION_QUESTION,
  UPDATE_TEMPLATE_SECTION_QUESTION_V2,
} from 'graphql/mutations/questions';
import {
  ADD_SONG_IDEAS_TO_TEMPLATE_SECTION,
  DELETE_SONG_IDEAS_FROM_TEMPLATE_SECTION,
  REORDER_TEMPLATE_SECTION_SONG_IDEAS,
  UPDATE_TEMPLATE_SECTION,
  UPDATE_TEMPLATE_SECTION_BLOCKS,
} from 'graphql/mutations/template';
import {
  GET_TEMPLATE_SECTION_COMPANY_SONG_IDEAS,
  GET_TEMPLATE_SECTION_SONG_IDEAS,
  GET_TEMPLATE_SECTION_USER_SONG_IDEAS,
  GET_TEMPLATE_SECTION_VIBO_SONG_IDEAS,
} from 'graphql/queries/template';

import { TemplateTimelineGqlOptions } from './interfaces';
import { EMPTY_MUTATION } from 'graphql/mutations/comon';

const DEFAULT_QUESTIONS_REFETCH_Q = ['templateSections', 'getTemplateSectionQuestionsV2'];

export const TEMPLATE_TIMELINE_GQL: TemplateTimelineGqlOptions = {
  sections: {
    mutations: {
      // @ts-ignore REMOVE TEMP
      moveQuestions: {
        mutation: EMPTY_MUTATION,
        refetchQ: ['templateSections', 'getTemplateSectionQuestionsV2'],
      },
      updateSection: {
        mutation: UPDATE_TEMPLATE_SECTION,
        refetchQ: ['templateSections'],
        updateCache: updateTemplateSectionCache,
      },
    },
    fragments: {
      section: TEMPLATE_SECTION,
    },
  },
  playlists: {
    queries: {
      user: {
        key: 'getTemplateSectionUserSongIdeas',
        query: GET_TEMPLATE_SECTION_USER_SONG_IDEAS,
      },
      vibo: {
        key: 'getTemplateSectionViboSongIdeas',
        query: GET_TEMPLATE_SECTION_VIBO_SONG_IDEAS,
      },
      company: {
        key: 'getTemplateSectionCompanySongIdeas',
        query: GET_TEMPLATE_SECTION_COMPANY_SONG_IDEAS,
      },
      section: {
        key: 'getTemplateSectionSongIdeas',
        query: GET_TEMPLATE_SECTION_SONG_IDEAS,
      },
      songs: {
        key: 'getTemplateSectionSongIdeasSongs',
        query: GET_TEMPLATE_SECTION_SONG_IDEAS_SONGS,
      },
    },
    mutations: {
      add: {
        mutation: ADD_SONG_IDEAS_TO_TEMPLATE_SECTION,
      },
      delete: {
        mutation: DELETE_SONG_IDEAS_FROM_TEMPLATE_SECTION,
      },
      reorder: {
        mutation: REORDER_TEMPLATE_SECTION_SONG_IDEAS,
      },
    },
  },
  questions: {
    queries: {
      questions: {
        query: GET_TEMPLATE_SECTION_QUESTIONS_V2,
        key: 'getTemplateSectionQuestionsV2',
      },
    },
    mutations: {
      create: {
        mutation: CREATE_TEMPLATE_SECTION_QUESTION_V2,
        refetchQ: DEFAULT_QUESTIONS_REFETCH_Q,
      },
      clone: {
        mutation: CLONE_TEMPLATE_SECTION_QUESTION,
        refetchQ: DEFAULT_QUESTIONS_REFETCH_Q,
      },
      update: {
        mutation: UPDATE_TEMPLATE_SECTION_QUESTION_V2,
        refetchQ: DEFAULT_QUESTIONS_REFETCH_Q,
      },
      reorder: {
        mutation: REORDER_TEMPLATE_SECTION_QUESTION,
        refetchQ: ['getTemplateSectionQuestionsV2'],
      },
      delete: {
        mutation: DELETE_TEMPLATE_SECTION_QUESTION,
        refetchQ: DEFAULT_QUESTIONS_REFETCH_Q,
      },
      updateBlocks: {
        mutation: UPDATE_TEMPLATE_SECTION_BLOCKS,
        refetchQ: DEFAULT_QUESTIONS_REFETCH_Q,
      },
    },
  },
};
